export default "__VITE_ASSET__95bc77d1__"